import { render, staticRenderFns } from "./NewsDetailView.vue?vue&type=template&id=254d57fa&scoped=true"
import script from "./NewsDetailView.vue?vue&type=script&lang=js"
export * from "./NewsDetailView.vue?vue&type=script&lang=js"
import style0 from "./NewsDetailView.vue?vue&type=style&index=0&id=254d57fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254d57fa",
  null
  
)

export default component.exports